module.exports = __webpack_public_path__ + "static/media/icon-martini.e34272eb.svg";